import styles from "./ExpectedBadge.module.css";

export interface ExpectedBadgeProps {
  isExpected: boolean;
  reason: string | null;
}

export function ExpectedBadge({ isExpected, reason }: ExpectedBadgeProps) {
  const label = isExpected ? "Expected" : "Unexpected";
  const className = `${styles.badge} ${isExpected ? styles.expected : styles.unexpected}`;
  const ariaLabel = reason ? `${label}: ${reason}` : label;

  return (
    <span className={className} title={reason ?? undefined} aria-label={ariaLabel}>
      {label}
    </span>
  );
}
